/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import React from 'react';
import { bool, func } from 'prop-types';

/**
 * Toggle is a Render Prop [ https://reactjs.org/docs/render-props.html ] used to toggle a single value.
 * Toggle has a single child that must be a function. The function is passed an object with the boolean `on`,
 * and three functions -`toggle`, `setOn`, `setOff`-  to update `on`.
 * The result of calling the function will be rendered.
 *
 * @example
 * <Toggle>
 *   {
 *      ( { on, toggle } ) =>
 *        <Lamp>
 *          <LightBulb isLit={on}/>
 *          <LightSwitch onFlip={toggle} />
 *        </Lamp>
 *   }
 * </Toggle>
 *
 * <Toggle>
 *   {
 *      ( { on, toggle } ) => <input type="checkbox" checked={on} onClick={toggle} />
 *   }
 * </Toggle>
 */
export default class Toggle extends React.Component {
  static propTypes = {
    initial: bool,
    children: func.isRequired
  };

  static defaultProps = {
    initial: false
  };

  state = {
    on: this.props.initial
  };

  set = (on) => this.setState({ on });

  render() {
    return this.props.children({
      on: this.state.on,
      toggle: () => this.set(!this.state.on),
      setOn: () => this.set(true),
      setOff: () => this.set(false)
    });
  }
}
